import { useEffect, useState, Fragment, forwardRef, useCallback } from 'react';
import { useGetTitularidadContratosQuery, useGetTitularidadContratosCdcQuery } from "../../../redux/reducers/titularidadcontratosSlice";
import { useGetContratosQuery, useGetContratosCdcQuery, useClasesContratosQuery } from "../../../redux/reducers/contratosSlice";
import { useGetPagosQuery, useAddPagoMutation, useEditPagoMutation, useDelPagoMutation } from "../../../redux/reducers/pagosSlice";
import { useGetCampanasQuery, useGetTiposCampanaQuery } from '../../../redux/reducers/campanasSlice';
import {
    useGetAdhesionesDebitoQuery,
} from '../../../redux/reducers/adhesionesDebitoSlice';
import { useGetCvusQuery, useAddCvusMutation } from '../../../redux/reducers/cvusSlice';
import { useGetPersonasQuery } from "../../../redux/reducers/personasSlice";
import { useGetIndicesQuery } from "../../../redux/reducers/indicesSlice";
import { useGetRolesMapQuery } from "../../../redux/reducers/rolesMapSlice";
import { getHistoriaFunc } from '../../../redux/reducers/_contratosSlice';
import { useGetRolesQuery } from "../../../redux/reducers/rolesSlice";
import { useGetCuponesQuery, useGetRegistrosMailQuery, useGetBatchEnviosMailQuery, useCrearCuponesMensualesMutation, useGetRegistrosMailByBatchIdQuery } from "../../../redux/reducers/registrosMailSlice";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IconButton from '@mui/material/IconButton';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Cancel"
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VerifiedIcon from '@mui/icons-material/Verified';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Popover from '@mui/material/Popover';
import dayjs from 'dayjs';
import pfc from '../../../pfc/functions'

import { setActualTime } from "../../../lib/dates.js";
import { FormContainer, TextFieldElement, SelectElement, MultiSelectElement, AutocompleteElement, DatePickerElement } from 'react-hook-form-mui';

import {
    Button, Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, DialogTitle, Dialog, Typography, DialogContent,
    TextField, FormControl, OutlinedInput, FormHelperText, InputLabel, FilledInput, Grid, DialogContentText, DialogActions, MenuItem, Select, Input, Stack
} from '@mui/material';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { getImporteNuevoMes, getConversionesCAC, getEstadosHistoricosCDC } from '../../../edilia/index';
import { selectCurrentUser } from "../../../redux/reducers/authSlice";
import {
    DataGridPro, GridToolbarQuickFilter, gridNumberComparator, GridToolbar, GridActionsCellItem, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton,
    GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';
import { getThemeProps } from '@mui/system';
import React from 'react';
import { getBatches, envioCupones, getDetallesBatch, getCuponesRegistro, message } from "./CuponesSlice.js";


// ... rest of your code

import _ from 'lodash';

import theme from "../../../theme";


const CuponesCat = () => {
    const currentUser = useSelector(selectCurrentUser);
    const Header = (props) => {
        const fetching = useSelector(state => state.cupones.fetching);
        const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        let fecha = new Date();
        let currentMonth = fecha.getMonth();
        let currentYear = fecha.getFullYear();
        return (<Fragment>
            <Typography variant="h5" component="div" sx={{ minWidth: 275, margin: '10px' }}>{'Cupones ' + meses[currentMonth] + ' ' + currentYear}</Typography>
            {fetching > 0 && <p>Cargando</p>}
        </Fragment>);
    };

    const CuponesTable = (props) => {
        const dispatch = useDispatch();
        const { fetching, message, error } = useSelector(state => state.cupones);
        const { cupones, batchEnvios, registrosMails, personas, clasesContratos, cvus, adhesionesDebito, tiposCampana, contratos } = useSelector(state => state.cupones.data);
        useEffect(() => { dispatch(getBatches()) }, []);
        const zfill = (number, width) => {
            var numberOutput = Math.abs(number); /* Valor absoluto del número */
            var length = number.toString()?.length; /* Largo del número */
            var zero = "0"; /* String de cero */

            if (width <= length) {
                if (number < 0) {
                    return ("-" + numberOutput.toString());
                } else {
                    return numberOutput.toString();
                }
            } else {
                if (number < 0) {
                    return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
                } else {
                    return ((zero.repeat(width - length)) + numberOutput.toString());
                }
            }
        };
        function padTo2Digits(num) {
            return num.toString().padStart(2, "0");
        };
        function getFecha(date) {
            date = new Date(parseInt(date)).toLocaleString().split(",");
            date = date[0].split("/");

            let m = date[1] < 10 ? padTo2Digits(date[1]) : date[1];
            let d = date[0] < 10 ? padTo2Digits(date[0]) : date[0];
            let y = date[2];
            return d + '/' + m + '/' + y
        };
        const getLabel = (option) => {
            if (option.personaFisica) {
                if (!option.nombre && !option.apellido && !option.numeroDocumento) return option.email;
                return option.nombre + ' ' + option.apellido + ' - ' + option.numeroDocumento;
            } else {
                if (!option.denominacionSocial && !option.cuit) return option.email;
                return option.denominacionSocial + ' - ' + option.cuit;
            }
        };
        function handleString(str) {
            str = str.replace('á', 'a');
            str = str.replace('Á', 'A');
            str = str.replace('é', 'e');
            str = str.replace('É', 'E');
            str = str.replace('í', 'i');
            str = str.replace('Í', 'I');
            str = str.replace('ó', 'o');
            str = str.replace('Ó', 'O');
            str = str.replace('ú', 'u');
            str = str.replace('Ú', 'U');
            str = str.replace('Ü', 'U');
            str = str.replace('ü', 'u');
            str = str.replace('Ñ', 'N');
            str = str.replace('ñ', 'n');
            str = str.replace("'", '');
            str = str.replace('`', '');
            str = str.replace('´', '');
            //str = str.toUpperCase()
            return str;
        };
        function debounce(func, wait) {

            let timeout;
            function executedFunction(...args) {
                let a = Date.now();
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };

            return executedFunction;
        };
        const getNombreMes = (fecha = new Date()) => {
            let mes = '';
            switch (fecha.getMonth() + 1) {
                case 1:
                    mes = "enero - " + fecha?.getFullYear();
                    break;
                case 2:
                    mes = "febrero - " + fecha?.getFullYear();
                    break;
                case 3:
                    mes = "marzo - " + fecha?.getFullYear();
                    break;
                case 4:
                    mes = "abril - " + fecha?.getFullYear();
                    break;
                case 5:
                    mes = "mayo - " + fecha?.getFullYear();
                    break;
                case 6:
                    mes = "junio - " + fecha?.getFullYear();
                    break;
                case 7:
                    mes = "julio - " + fecha?.getFullYear();
                    break;
                case 8:
                    mes = "agosto - " + fecha?.getFullYear();
                    break;
                case 9:
                    mes = "septiembre - " + fecha?.getFullYear();
                    break;
                case 10:
                    mes = "octubre - " + fecha?.getFullYear();
                    break;
                case 11:
                    mes = "noviembre - " + fecha?.getFullYear();
                    break;
                case 12:
                    mes = "diciembre - " + fecha?.getFullYear();
                    break;
                default:
                    mes = "En espera";
                    break;
            }
            return mes
        };
        const timeOut = (ms) => new Promise((res, rej) => setTimeout(res, ms));
        const [showMailForm, setShowMailForm] = useState(false);
        const moneyFormat = (v) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "ARS" }).format(parseFloat(v).toFixed(2)).replace('ARS', '');
        const getTipologia = (id) => {
            let x = clasesContratos?.find(x => parseInt(x.claseContratoId) === parseInt(id))?.codigo
            switch (x) {
                case '1AMB-STD-QI':
                    return 'Estudio Profesional';
                case '2AM-STD-QI':
                    return '2 Ambientes';
                case '3AMB-STD-QI':
                    return '3 Ambientes';
                case '3AMB-PLUS-QI':
                    return '3 Ambientes Esquina';
                case 'COCH-STD-QI':
                    return 'Cochera';
                case 'BAUL-STD-QI':
                    return 'Baulera';
                default:
                    throw new Error('No se reconoce la clase.');
            }

        };
        const GridAction = (props) => {
            const [anchorEl, setAnchorEl] = useState(null);

            const handlePopoverOpen = (event) => {
                setAnchorEl(event.currentTarget)
            };

            const handlePopoverClose = () => {
                setAnchorEl(null)
            };
            const { label, key, Icon } = props;
            const open = Boolean(anchorEl);
            return (
                <Fragment key={key + label}>
                    <Icon aria-owns={open ? label : undefined}
                        aria-haspopup="true"
                        onMouseEnter={handlePopoverOpen}
                        onMouseLeave={handlePopoverClose}> </Icon>
                    <Popover
                        id={label}
                        sx={{
                            pointerEvents: 'none',
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>{label}</Typography>
                    </Popover>
                </Fragment>
            )
        };
        const rows = [...(batchEnvios || [])]?.sort((a, b) => b.batchEnvioMailsId - a.batchEnvioMailsId);
        //Detalles Batch
        const [showDetallesBatch, setShowDetallesBatch] = useState(false);
        const DetalleModalBatch = (props) => {
            let id = showDetallesBatch.batchEnvioMailsId
           // useEffect(() => { dispatch(getDetallesBatch(id)) }, []);
            const registrosDelBatch = registrosMails?.filter(r=> r.batchEnvioMailsId === id)?.map(r => {
                const persona = personas?.find(p=> p.email === r.mailTo)
                return ({...r, titularId: persona?.personaId, nombreTitular: getLabel(persona)})
            })//useSelector(state => state.cupones.detallesBatch); //registrosMails?.filter(r=> r.batchEnvioMailsId === id)//
            const [rowsRegistrosMail, setRowsRegistrosMail] = useState(registrosDelBatch)//useState([]);
            // const actualizarRegistros = async () => {
            //     await timeOut(5000);
            //     let isEnviosEnEspera = rowsRegistrosMail?.find((r) => r.result === null);
            //     if (isEnviosEnEspera) {
            //         dispatch(getDetallesBatch(id))
            //     }
            //     console.log('Actualizando...')
            //     setRowsRegistrosMail(registrosDelBatch || [])?.map(c => {
            //         const titular = personas?.find(p => p.email === c.mailTo)
            //         return ({
            //             ...c,
            //             titularId: titular?.personaId,
            //             nombreTitular: getLabel(titular)
            //         })
            //     })
            // };

            // useEffect(() => {
            //     actualizarRegistros();
            // }, [registrosDelBatch]);

            const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState([])
            const handleDetailPanelExpandedRowIdsChange = React.useCallback((newIds) => {
                setDetailPanelExpandedRowIds(newIds);
            }, []);
            const columnsR = [
                { field: 'registroMailId', headerName: 'Mail ID', width: 100 },
                { field: 'fechaEnvio', headerName: 'Fecha Envio', width: 100, valueGetter: (v) => v.row.fechaEnvio ? getFecha(v.row.fechaEnvio) : 'En espera' },
                { field: 'mes', headerName: 'Mes', width: 10, width: 100, valueGetter: (v) => getNombreMes(new Date(parseInt(v.row.fechaEnvio))) },
                { field: 'titularId', headerName: 'Titular ID', width: 100, },
                { field: 'nombreTitular', headerName: 'Nombre', width: 100, },
                { field: 'mailTo', headerName: 'Email', width: 150, },
                { field: 'template', headerName: 'Template', width: 100, },
                { field: 'result', headerName: 'Result', width: 100, renderCell: (v) => v.row.result === null ? (<ScheduleIcon color="secondary" />) : v.row.result === 'mail OK:' ? (<CheckCircleIcon color="primary" />) : <ClearIcon color="danger" /> },

            ];
            const DetalleRegistro = (props) => {
                let id = props.row.registroMailId
                const cuponesDelRegistro = (cupones || [])?.filter(c=> c.registroMailId === id)//useSelector(state => state.cupones.cuponesRegistro); //
               // useEffect(() => { dispatch(getCuponesRegistro(id)) }, []);
                const [rowsCuponesMail, setRowsCuponesMail] = useState(cuponesDelRegistro);
                let cuponesRegistro = (rowsCuponesMail || [])?.map(x => {
                    let contrato = (contratos)?.find(c => c.contratoId === x.contratoId)
                    let tipologia = getTipologia(contrato?.claseContratoId)
                    return ({
                        ...x,
                        tipologia
                    })
                });
                const columnsC = [
                    {
                        field: "contratoId",
                        headerName: "Contrato ID",
                        width: 60,
                    },
                    {
                        field: "tipologia",
                        headerName: "Tipo de contrato",
                        width: 200,
                    },
                    {
                        field: "monto",
                        headerName: "Monto",
                        width: 150,
                    },
                    {
                        field: "plan",
                        headerName: "Plan",
                        width: 150,
                    },
                    {
                        field: "bonificacion",
                        headerName: "Bonificación",
                        width: 150,
                    },
                    {
                        field: "template",
                        headerName: "Template",
                        width: 150,
                    },
                ];
                return (
                    <Box >
                        <Typography fontWeight={600} style={{ color: theme.palette.success.main }} >Cupones adjuntos: </Typography>
                        {cuponesRegistro?.length === 0 ? null :
                            <Grid container>
                                <Grid item xs={12} children={<Typography fontWeight={700} childern={'Cupones: '} />} />
                                <Grid item xs={12}>
                                    <DataGridPro
                                        pagination
                                        fullWidth
                                        getRowId={(r) => r.cuponId}
                                        initialState={{
                                            sorting: {
                                                sortModel: [{ field: "ID", sort: "asc" }],
                                            },
                                        }}
                                        rows={cuponesRegistro}
                                        columns={columnsC}
                                        experimentalFeatures={{ newEditingApi: true }}
                                        hideFooter
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Box>
                );
            };
            return (
                <Dialog
                    onClose={() => setShowDetallesBatch(false)}
                    open={showDetallesBatch}
                    maxWidth="lg"
                    //fullWidth
                >
                    <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>
                        Detalles Batch de Envíos N° {showDetallesBatch.batchEnvioMailsId}:
                    </DialogTitle>
                    <DialogContent dividers>
                        <Box //fullWidth
                        >
                            <Grid container>
                                <Grid item xs={12}>
                                    <DataGridPro
                                        fullWidth
                                        pagination
                                        style={{ minHeight: '60vh' }}
                                        getRowId={(r) => r.registroMailId}
                                        //rows={currentUser?.permisos?.find((p) => p !== 'readPagos') && rowsRegistrosMail ? rowsRegistrosMail : []}
                                        rows={rowsRegistrosMail}
                                        columns={columnsR}
                                        slotProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                            },
                                        }}
                                        initialState={{
                                            columns: {
                                                columnVisibilityModel: {
                                                    // personaId: false,
                                                    cuotaEsperaMesRestante: false,
                                                    adelantoRecurrenteMesRestante: false,
                                                    refuerzoSemestreCuotaEsperaRestante: false,
                                                    refuerzoSemestreAdelantoRecurrenteRestante: false,
                                                    cuotaPrimaRestante: false,
                                                    cuotaPosesionRestante: false,
                                                    importeSinCampanaCupon: false,
                                                },
                                            },
                                        }}
                                        getDetailPanelContent={({ row }) => (
                                            <DetalleRegistro row={row} />
                                        )}
                                        getDetailPanelHeight={({ row }) => cupones?.filter((c) => c.registroMailId === row.registroMailId).length * 180}
                                        detailPanelExpandedRowIds={detailPanelExpandedRowIds}
                                        onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}
                                        loading={rowsRegistrosMail?.length !== 0 ? false : true}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowDetallesBatch(false)}>
                            Volver
                        </Button>
                    </DialogActions>
                </Dialog>
            );
        };
        const columns = [
            { field: 'batchEnvioMailsId', headerName: 'Batch ID', width: 200 },
            { field: 'fechaCreacion', headerName: 'Fecha Creacion', width: 300, valueGetter: (v) => getFecha(v.row.fechaCreacion) },
            { field: 'mes', headerName: 'Mes', width: 300, valueGetter: (v) => getNombreMes(new Date(parseInt(v.row.fechaCreacion))) + '-' + new Date(parseInt(v.row.fechaCreacion)).getFullYear() },
            {
                field: 'actions',
                headerName: 'Acciones',
                width: 300,
                type: 'actions',
                renderCell: (v) => (
                    <>

                        <GridActionsCellItem
                            key={v.row.batchEnvioMailsId + '-verDetallesGridAction'}
                            color={'primary'}
                            onClick={() => setShowDetallesBatch(v.row)}
                            icon={
                                <GridAction
                                    label={'Ver Detalles'}
                                    key={'batch-mail-envio-' + v.row.batchEnvioMailsId}
                                    Icon={VisibilityIcon}
                                />
                            }
                        />
                    </>
                ),
            },
        ];
        const BtnBar = (props) => {
            return (
                <Fragment>
                    <Button className="mb-3" disabled={fetching > 0}variant="contained" color='primary' sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }} onClick={() => setShowMailForm(true)}>NUEVO<AddIcon /></Button>
                </Fragment>)
        };
        const NewBatchEnvioForm = (props) => {

            const [msjFooter, setMsjFooter] = useState([]);
            const [showConfirmationModal, setShowConfirmationModal] = useState(false)
            const [selectedRows, setSelectedRows] = useState([]);
            let adhesionesActuales = (adhesionesDebito)?.filter(a => !a.eliminado && (new Date(parseInt(a.fechaVencimiento))?.getMonth() === new Date().getMonth() && new Date(parseInt(a.fechaVencimiento))?.getFullYear() === new Date().getFullYear()))
            let diaDebito = adhesionesActuales?.map(a => new Date(parseInt(a.fechaVencimiento)).getDate())?.join('/');

            let mes = getNombreMes()
            let fecha = new Date()
            let currentMonth = fecha.getMonth()
            let currentYear = fecha.getFullYear()
            const getCategoria = (nuevoMes, campanas) => {
                let campanasActivas = nuevoMes?.campanasActivas
                //No Aplica
                let isNoCuota = (campanasActivas || [])?.find(c => tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre === 'Per Cuota Ahorro' && c.creacion);
                //Plan de Pago
                let isPlanPago = (campanasActivas || [])?.find(c => tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre === 'Per Cupon');
                //2 Indices
                let is2indices = (campanas || [])?.find(c => tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre === 'Per Cuota Ahorro' && c.creacion && ((fecha.getMonth() + fecha.getFullYear() * 12) - (new Date(parseInt(c.fechaFinalizacion)).getMonth() + new Date(parseInt(c.fechaFinalizacion)).getFullYear() * 12)) === 1);
                //Bonif
                let isBonifPAE = nuevoMes?.estado?.pagosActivables?.find(p => p.activado && p.descripcion.startsWith('Bonificación PAE'));
                let isBonifReferido = nuevoMes?.estado?.pagosActivables?.find(p => p.activado && p.descripcion.startsWith('Bonificación Referido'));
                //Refuerzo
                let isContratoRefuerzo = nuevoMes?.contratoActual?.mesRefuerzoSemestral1 === fecha.getMonth() || nuevoMes?.contratoActual?.mesRefuerzoSemestral1 === fecha.getMonth()
                let isAplicaRefuerzo = !(campanasActivas || [])?.find(c => tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre === 'Per Refuerzo Ahorro' && c.creacion) && isContratoRefuerzo
                //if (nuevoMes.contratoActual.contratoId === 153) console.log('CATEGORIA', nuevoMes.contratoActual.contratoId, nuevoMes.estado.pagosActivables, "CAMPANAS", campanasActivas, 'IsPLAN:', isPlanPago, isContratoRefuerzo, 'MES', fecha.getMonth(), nuevoMes.contratoActual.mesRefuerzoSemestral1, isBonifPAE)
                //Necesito tu ayuda aquí
                if (isPlanPago && isAplicaRefuerzo) return "Refuerzo + Plan de Pago"
                else if (isBonifPAE && is2indices) return "CAMPAÑA + doble indice"
                else if (isPlanPago) return 'Plan de Pago'
                else if (isBonifPAE) return "CAMPAÑA entonces tu aporte es solo"
                else if (is2indices) return "Doble Indice"
                else if (isAplicaRefuerzo) return "Refuerzo"
                else if (isBonifReferido) return 'Gracias por Referir'
                else if (isNoCuota) return "-"
                else return 'ESTANDAR'
            };
            const getBonif = (nuevoMes) => {
                let montoBonif = nuevoMes?.estado?.pagosActivables.reduce((acum, pago) => {
                    let total = pago.activado ? acum + (pago.montoNominal / 100).toFixed(2) : acum
                    return total
                }, 0);
                return montoBonif;
            };
            const isRowSelectable = (campanas) => {
                let campanaAhorroId = tiposCampana?.find(t => t.nombre === 'Per Cuota Ahorro').tipoCampanaId;
                let isCampanaAhorro = campanas?.find(c => c.tipoCampanaId === campanaAhorroId && c.creacion && c.parametros.porcentaje === 0);
                return isCampanaAhorro ? false : true
            };
            const [rowsForm, setRowsForm] = useState((contratos)?.filter(c => c.estado === 'Activo')?.map(c => {
                let nuevoMes = c.historia?.find(h => h.operacion?.tipo === 'Nuevo Mes' && (new Date(h.fecha).getFullYear() === currentYear && new Date(h.fecha).getMonth() === currentMonth))
                nuevoMes = nuevoMes ? nuevoMes : (_.last(c.historia))
                const importes = getImporteNuevoMes(nuevoMes);
                let campanasActivas = nuevoMes?.campanasActivas
                let titularPrincipal = personas?.find(p => parseInt(p.personaId) === parseInt(nuevoMes?.titularidadesActuales?.find(t => t.titularPrincipal)?.personaId))
                //if (c.contratoId === 170) console.log('titu', (_.last(c.historia)))
                let cvuContrato = (cvus)?.find(x => parseInt(x.contratoId) === parseInt(c.contratoId));
                //let isPlanPago = (campanasActivas || [])?.find(c => tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre === 'Per Cupon')
                let bonificacion = getBonif(nuevoMes);
                let categoria = getCategoria(nuevoMes, c.campanas) //isPlanPago ? 'Plan de Pago' : 'ESTANDAR'
                let plan = importes?.plan * 100 + '%';
                let tipologia = getTipologia(c.claseContratoId);
                //Refuerzo
                let isContratoRefuerzo = nuevoMes?.contratoActual?.mesRefuerzoSemestral1 === fecha.getMonth() || nuevoMes?.contratoActual?.mesRefuerzoSemestral1 === fecha.getMonth()
                let isAplicaRefuerzo = !(campanasActivas || [])?.find(c => tiposCampana?.find(t => t.tipoCampanaId === c.tipoCampanaId)?.nombre === 'Per Refuerzo Ahorro' && c.creacion) && isContratoRefuerzo
                return ({
                    cvu: cvuContrato?.cvu,
                    contratoId: c.contratoId,
                    titularId: titularPrincipal?.personaId,
                    nombreTitular: titularPrincipal ? handleString(getLabel(titularPrincipal)?.split('-')[0]) : '',
                    email: titularPrincipal?.email,
                    campanasActivas,
                    importeTotal: importes?.importeTotal,//null,
                    // importeSinCampanaCupon: importes?.importeSinCampanaCupon,
                    // cuotaEsperaMesRestante: importes?.cuotaEsperaMesRestante,//null,
                    // adelantoRecurrenteMesRestante: importes?.adelantoRecurrenteMesRestante,//null,
                    // refuerzoSemestreCuotaEsperaRestante: importes?.refuerzoSemestreCuotaEsperaRestante,//null,
                    // refuerzoSemestreAdelantoRecurrenteRestante: importes?.refuerzoSemestreAdelantoRecurrenteRestante,//null,
                    // cuotaPrimaRestante: importes?.cuotaPrimaRestante,//null,
                    // cuotaPosesionRestante: importes?.cuotaPosesionRestante,//null,
                    aplicaRefuerzo: isAplicaRefuerzo ? true : false,
                    bonificacion,
                    categoria,
                    plan,
                    mes,
                    diaDebito: diaDebito ? diaDebito : '',
                    monto: '$ ' + moneyFormat(importes?.importeTotal),
                    tipologia
                })
            }));
            const [bonificaciones, setBonificaciones] = useState([...rowsForm?.map(r => ({ contratoId: r.contratoId, bonificacion: r.bonificacion }))]);
            const [categorias, setCategorias] = useState([...rowsForm?.map(r => ({ contratoId: r.contratoId, categoria: r.categoria }))]);
            const CategoriaCell = (v) => {
                const [categoria, setCategoria] = useState(categorias?.find(m => m.contratoId === v.row.contratoId)?.categoria);
                const handleChange = (e) => {
                    setCategorias([
                        ...categorias.map((r) =>
                            r.contratoId === v.row.contratoId
                                ? { ...r, categoria: e.target.value, }
                                : r,
                        ),
                    ]);
                    setCategoria(e.target.value);
                }
                return (<FormControl fullWidth key={v.row.contratoId + 'CategoriaCell'}>
                    <Select labelId="seleccion-clase-contrato" value={categoria} label="" onChange={handleChange}>
                        {['ESTANDAR', 'Plan de Pago', 'Gracias por Referir', "CAMPAÑA entonces tu aporte es solo", "Doble Indice", "CAMPAÑA + doble indice", "Refuerzo", "Refuerzo + Plan de Pago", '-']?.map((x, index, array) => (
                            <MenuItem value={x} disabled={x === '-' || !isRowSelectable(v.row.campanasActivas)}>{x}</MenuItem>
                        ))}
                    </Select>
                </FormControl>)
            };
            const BonificacionCell = (v) => {
                const [bonificacion, setBonificacion] = useState(bonificaciones?.find(m => m.contratoId === v.row.contratoId)?.bonificacion) //(numberImputs.find(c => c.clienteDebitoId === v.row.clienteDebitoId).importeDebitoAdhesion)

                const handleChange = (e) => {
                    setBonificacion(e.target.value);
                    debounce(setBonificaciones([
                        ...bonificaciones.map((c) =>
                            c.contratoId === v.row.contratoId ? { ...c, bonificacion: e.target.value } : c,
                        ),
                    ]));
                };
                return (
                    <FormControl fullWidth key={v.row.contratoId + 'bonificacion-cell'}>
                        <Input value={bonificacion} onChange={handleChange} id="outlined-adornment-weight" type="number" />
                    </FormControl>
                );
            };
            const handleValidation = () => {
                setMsjFooter([]);
                let huboError = false;
                if (selectedRows?.length === 0) {
                    setMsjFooter([...msjFooter, 'No se ha cargado una adhesión al débito directo este mes.'])
                    huboError = true
                };
                if (adhesionesActuales?.length === 0) {
                    setMsjFooter([...msjFooter, 'No se ha cargado una adhesión al débito directo este mes.'])
                    huboError = true
                };
                for (const row of [...rowsForm]?.filter(r => selectedRows?.includes(r.contratoId))) {
                    if (!row.cvu) {
                        setMsjFooter([...msjFooter, `No se ha cargado el CVU para el contrato ID: ${row.contratoId}.`])
                        huboError = true
                    };
                }
                if (huboError) { return } else { setShowConfirmationModal(true) }
            };
            const ModalConfirmacion = () => {
                return (
                    <Dialog maxWidth='md' onClose={() => setShowConfirmationModal(false)} open={showConfirmationModal}>
                        <DialogTitle style={{ backgroundColor: theme.palette.success.main, color: 'white', fontWeight: 'bold' }} >Confirmación de envío:</DialogTitle>
                        <DialogContent dividers>
                            <Typography children={`Se enviarán ${selectedRows?.length} cupones.`} />
                            <Typography children={`Confirme si desea realizar la acción, la misma no podrá deshacerse.`} />
                            <Typography children={``} />
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={() => setShowConfirmationModal(false)} sx={{ marginTop: '10px', fontWeight: "bold" }}>{"Cancelar"}</Button>
                            <Button variant="contained" onClick={() => onSubmit()} type={'submit'} sx={{ marginRight: '5px', marginTop: '10px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
                        </DialogActions>
                    </Dialog>
                )
            }
            const columnsForm = [
                { field: 'contratoId', headerName: 'ID Contrato', width: 50 },
                { field: 'tipologia', headerName: 'Tipologia', width: 100, },
                { field: 'nombreTitular', headerName: 'Nombre', width: 150, },
                { field: 'email', headerName: 'Email', width: 150, },
                { field: 'importeTotal', headerName: 'Importe ', width: 100, valueGetter: (v) => v.row.importeTotal ? '$' + moneyFormat(v.row.importeTotal) : '-' },
                { field: 'categoria', headerName: 'Categoría Mail', width: 150, renderCell: CategoriaCell },
                { field: 'bonificacion', headerName: 'Bonificacion', width: 150, renderCell: BonificacionCell },
                { field: 'plan', headerName: 'Plan', width: 100, }

            ];
            const onSubmit = () => {
                let selectedRowsAux = [...rowsForm]?.filter(r => selectedRows?.includes(r.contratoId))?.map(r => {
                    let bonificacion = '$ ' + moneyFormat(bonificaciones?.find(b => b.contratoId === r.contratoId).bonificacion)
                    let categoria = categorias?.find(b => b.contratoId === r.contratoId).categoria
                    return ({
                        ...r,
                        bonificacion,
                        categoria
                    })
                })
                try {
                    const resultAction = dispatch(envioCupones(selectedRowsAux));
                    setShowConfirmationModal(false)
                    setShowMailForm(false);
                    // Haz algo con el resultado si es necesario
                } catch (error) {
                    // Maneja el error
                    console.error("Error en envioCupones:", error);
                    setShowConfirmationModal(false)
                    setShowMailForm(false);
                }
            };
            return (
                <Dialog maxWidth='xl' onClose={() => setShowMailForm(false)} open={showMailForm}>
                    <ModalConfirmacion />
                    <DialogTitle style={{ backgroundColor: theme.palette.success.main, color: 'white', fontWeight: 'bold' }} >Envío de cupones mensuales:</DialogTitle>
                    <DialogContent dividers>
                        <Box fullWidth sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                        }}>
                            <Grid container >
                                <Grid item xs={12} children={`Día débito: ${diaDebito || 'No se a creado un adhesión este mes.'}`} />
                                <Grid item xs={12} children={<DataGridPro fullWidth
                                    pagination
                                    style={{ height: '60vh' }}
                                    getRowId={r => r.contratoId}
                                    rows={currentUser?.permisos?.find(p => p !== "readPagos") && rowsForm ? rowsForm : []}
                                    columns={columnsForm}
                                    //autoPageSize
                                    components={{
                                        Toolbar: () => {
                                            return <Fragment>
                                                <GridToolbarContainer>
                                                    <Grid conteiner
                                                        rowSpacing={0} sx={{
                                                            display: "inline-flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "strech",
                                                            width: "100%"
                                                        }}>
                                                        <Grid sx={{ width: "100%" }}>
                                                            <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                                                            {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                                                                : ''}
                                                        </Grid>
                                                        <GridToolbarQuickFilter />
                                                    </Grid>
                                                </GridToolbarContainer>
                                            </Fragment>
                                        }
                                    }}
                                    componentsProps={{ toolbar: { showQuickFilter: true, quickFilterProps: { debounceMs: 500 } } }}
                                    checkboxSelection
                                    disableRowSelectionOnClick
                                    rowSelectionModel={selectedRows}
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setSelectedRows(newRowSelectionModel);
                                    }}
                                    isRowSelectable={(params) => isRowSelectable(params.row.campanasActivas)}

                                />} />
                                {msjFooter?.map((m, i) => {
                                    return (
                                        <Grid key={'msjFooter' + i} children={<Typography color={theme.palette.danger.main} children={m} />} item xs={12} />)
                                })
                                }
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setShowMailForm(false)} sx={{ marginTop: '10px', fontWeight: "bold" }}>{"Cancelar"}</Button>
                        <Button variant="contained" disabled={true} onClick={() => handleValidation()} type={'submit'} sx={{ marginRight: '5px', marginTop: '10px', fontWeight: "bold", color: "white" }}>{"Aceptar"}</Button>
                    </DialogActions>
                </Dialog>
            )
        };
        return (
            <Fragment>
                {showMailForm ? <NewBatchEnvioForm /> : null}
                {showDetallesBatch ? <DetalleModalBatch /> : null}
                
                <Box fullWidth>
                    <DataGridPro
                        fullWidth
                        pagination
                        sx={{ height: '75vh' }}
                        getRowId={r => r.batchEnvioMailsId}
                        rows={(rows || [])}
                        columns={columns}
                        components={{
                            Toolbar: () => {
                                return <Fragment>
                                    <GridToolbarContainer>
                                        <Grid conteiner
                                            rowSpacing={0} sx={{
                                                display: "inline-flex",
                                                justifyContent: "space-between",
                                                alignItems: "strech",
                                                width: "100%"
                                            }}>
                                            <Grid sx={{ width: "100%" }}>
                                                <BtnBar />
                                                <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                                                {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                                                    : ''}
                                            </Grid>
                                            <GridToolbarQuickFilter />
                                        </Grid>
                                    </GridToolbarContainer>
                                </Fragment>
                            }
                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'documentoId', sort: 'desc' }],
                            },
                            innedColumns: { right: ['actions'] }
                        }}
                        loading={rows && fetching === 0  ? false : true}
                    />
                </Box>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Header></Header>
            <CuponesTable />
        </Fragment>
    )
};

export default CuponesCat;